import React, { FC } from "react";
import { useHasAuthRole } from "../../src/hooks/useAuthRole";
import { PageDoesntExist } from "../../src/pageDoesntExist";

const AuthRoleWrapper: FC<{ Component: React.FC }> = ({
  Component,
}): JSX.Element => {
  const hasAuthRole = useHasAuthRole();
  return hasAuthRole ? <Component /> : <PageDoesntExist />;
};

export default AuthRoleWrapper;
